import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (bench) => ({
    'default': [
        {
            id: 'info',
            label: '',
            align: AlignTypes.left,
        },
        {
            id: 'carteira',
            label: 'Carteira',
            align: AlignTypes.right,
        },
        {
            id: 'bench',
            label: bench !== null && bench !== void 0 ? bench : '-',
            align: AlignTypes.right,
        },
    ],
    'info2': [
        {
            id: 'info',
            label: '',
            align: AlignTypes.left,
        },
        {
            id: 'valor',
            label: 'Valor',
            align: AlignTypes.right,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
    ]
});
